import './EditArticleModal.css';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}

export function DeleteConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm,
  title = 'Confirmar Exclusão',
  message = 'Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.'
}: DeleteConfirmationModalProps) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content delete-confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button 
            className="close-button"
            onClick={onClose}
            aria-label="Fechar modal"
          >
            ×
          </button>
        </div>
        <p>{message}</p>
        <div className="modal-actions">
          <button 
            onClick={onClose}
            className="cancel-delete-button"
          >
            Cancelar
          </button>
          <button 
            onClick={onConfirm}
            className="confirm-delete-button"
          >
            Sim, excluir
          </button>
        </div>
      </div>
    </div>
  );
} 